import React from 'react'

interface BaseContactInputProps {
  id: string
  label: string
  isChecked: boolean
  onCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onBlur: () => void
  error?: string
  isSubmitting: boolean
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>
}

const BaseContactInput: React.FC<BaseContactInputProps> = ({
  id,
  label,
  isChecked,
  onCheckboxChange,
  value,
  onChange,
  onBlur,
  error,
  isSubmitting,
  inputProps
}) => {
  return (
    <div className="space-y-3">
      <div className="flex items-center space-x-2">
        <input
          type="checkbox"
          id={`wants${id}`}
          checked={isChecked}
          onChange={onCheckboxChange}
          className="w-6 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
          disabled={isSubmitting}
        />
        <label htmlFor={`wants${id}`} className="text-gray-700 cursor-pointer">
          {label}
        </label>
      </div>

      {isChecked && (
        <div className="ml-7 space-y-1">
          <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">
            {id === 'email' ? 'Correo electrónico' : id === 'phone' ? 'Teléfono' : 'Dato de contacto'}
          </label>
          <input
            id={id}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none ${
              error ? 'border-red-500' : 'border-gray-300'
            }`}
            disabled={isSubmitting}
            required={isChecked}
            {...inputProps}
          />
          {error && <p className="text-red-500 text-sm">{error}</p>}
        </div>
      )}
    </div>
  )
}

export default BaseContactInput
